import {MenuItem} from '@material-ui/core';
import {DebtorActionType} from './DebtorActionHelper';
import React, {useState} from 'react';
import {NewPaymentDialog} from '../../payments/dialogs/NewPaymentDialog';

const DebtorNewPaymentAction = React.forwardRef(({ debtor, setMenuAnchor, label }: DebtorActionType, ref: React.Ref<any>) => {
  const [openDialog, setOpenDialog] = useState(false);

  //reload count
  return (
    <div key={debtor.id + 'newPaymentC'} ref={ref}>
      <MenuItem
        key={debtor.id + 'newPayment'}
        onClick={() => {
          setMenuAnchor(null);
          setOpenDialog(true);
        }}
      >
        {label}
      </MenuItem>
      {openDialog && (
        <NewPaymentDialog onSuccess={() => setOpenDialog(false)} isOpen={openDialog} onCancel={() => setOpenDialog(false)} debitor={debtor} />
      )}
    </div>
  );
});

export default DebtorNewPaymentAction;
